<div class="dashboard-checklist">
    <div class="checklist-items">
        <div class="checklist-item" *ngFor="let item of checklistItems">
            <h4>{{item.name}}</h4>
            <div class="icon">
                <img id="inactive" 
                    *ngIf="item.status !== this.checkListStatuses.COMPLETED" 
                    src="../../../../assets/images/check-inactive.svg" 
                    alt="{{item.name}} is inactive"
                    height="30" width="30"/>
                <img id="completed" 
                    *ngIf="item.status !== this.checkListStatuses.INACTIVE" 
                    src="../../../../assets/images/check-complete.svg" 
                    alt="{{item.name}} is completed"
                    height="30" width="30"/>
            </div>
        </div>
    </div>
</div>
